module.exports = __webpack_public_path__ + "media/images/top/qa/qa_show_sp_banner02-9c287f342c9fcf6ce0c7f4adb06dce68.png";